import { Injectable } from '@angular/core';
import { HttpEvent } from '@angular/common/http';

import { Observable } from 'rxjs';

import { UploadIds } from 'src/app/models/upload';
import { StudySubscription } from '../../../models/subscription';
import { InformativePage } from 'src/app/models/informative-page';
import { ApiService } from '../../../core/services/api/api.service';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionService {
  getSubscription(studyId: number): Observable<StudySubscription> {
    return this.apiService.get<StudySubscription>(`/dashboard/study/${studyId}/enrolment`);
  }

  updateSubscription(subscription): Observable<StudySubscription> {
    return this.apiService.put<StudySubscription>(`/dashboard/study/${subscription.study_id}/enrolment`, subscription);
  }

  updateSubscriptionInformativePage(page): Observable<InformativePage> {
    const { study_id, page_id, ...payload } = page;

    return this.apiService.put<InformativePage>(
      `/dashboard/study/${study_id}/enrolment/page/${page_id}`,
      payload
    );
  }

  createSubscriptionInformativePage(page): Observable<InformativePage> {
    return this.apiService.post<InformativePage>(`/dashboard/study/${page.study_id}/enrolment/page`, page);
  }

  deleteSubscriptionInformativePage(page): Observable<InformativePage> {
    return this.apiService.delete<InformativePage>(`/dashboard/study/${page.study_id}/enrolment/page/${page.id}`);
  }

  uploadSubscriptionInformativePageImage(imageFile: File, idsForUpload: UploadIds): Observable<HttpEvent<string[]>> {
    const body: FormData = new FormData();
    const studyId = idsForUpload?.studyId || 0;
    body.append('uploads[]', imageFile, imageFile.name);
    return this.apiService.post<HttpEvent<string[]>>(
      `/dashboard/study/${studyId}/enrolment/page/upload`,
      body,
      {
        reportProgress: true,
        observe: 'events',
      }
    );
  }

  constructor(private apiService: ApiService) {}
}
